/** The AI notice is opt-in per avatar: only an explicit `true` shows it. */
export function shouldShowAiNotice(content?: { show_ai_notice?: boolean } | null): boolean {
  return content?.show_ai_notice === true;
}

/** The learner can start only once every consent point is ticked. */
export function allAiNoticePointsAccepted(checked: boolean[]): boolean {
  return checked.length > 0 && checked.every(Boolean);
}
